import { useState } from 'react'
import { sleepSeconds } from '~/utils/promise'

// 再試行が一瞬で完了すると「ボタンが反応しない」と誤解されるため、
// ローディング表示に最低限の時間を保証する
const RETRY_MIN_LOADING_SECONDS = 0.5

/**
 * 「再試行」ボタンの状態管理。
 * 再試行の実体（fetchSession / GET /me の再取得 等）は呼び出し側が渡し、
 * 成功なら true を返す。ローディングは最低 RETRY_MIN_LOADING_SECONDS 表示する。
 * retryAction が例外を投げた場合も失敗として扱い、ボタンがローディングのまま
 * 固まらないようにする。
 */
export const useKioskRetry = (retryAction: () => Promise<boolean>) => {
  const [isRetrying, setIsRetrying] = useState(false)
  const [isRetryFailed, setIsRetryFailed] = useState(false)

  const retry = async () => {
    setIsRetrying(true)
    setIsRetryFailed(false)
    let succeeded = false
    try {
      // 直列で待つと常に「待機 + 処理」の合計時間になるため、並行にして
      // max(最低保証, 処理時間) にする
      ;[, succeeded] = await Promise.all([
        sleepSeconds(RETRY_MIN_LOADING_SECONDS),
        retryAction(),
      ])
    } catch {
      succeeded = false
    } finally {
      setIsRetrying(false)
    }
    if (!succeeded) {
      setIsRetryFailed(true)
    }
    return succeeded
  }

  return { isRetrying, isRetryFailed, retry }
}
